/**
 * CommentUpdateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentUpdateRes
 */
export interface CommentUpdateRes {
  /** 是否成功 */
  success?: boolean
}

/**
 * CommentUpdateRes Schema
 */
export const CommentUpdateResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '是否成功',
      format: 'bool',
      type: 'boolean',
      label: '是否成功',
    },
  },
  type: 'object',
}
